import * as tslib_1 from "tslib";
import { HttpClient } from "@angular/common/http";
import { environment } from '../../../../environments/environment';
var UserinfoService = /** @class */ (function () {
    function UserinfoService(http) {
        this.http = http;
        this.baseUrl = "" + environment.apiHost;
        this.path = '/makpak/userinfo';
    }
    UserinfoService.prototype.loadUserInfo = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.http.get(this.baseUrl + this.path).toPromise()];
                    case 1:
                        response = _a.sent();
                        this.userinfo = JSON.parse(JSON.stringify(response));
                        return [2 /*return*/, this.userinfo];
                }
            });
        });
    };
    UserinfoService.prototype.getUserinfo = function () {
        return this.userinfo;
    };
    UserinfoService.prototype.setUserinfo = function (user) {
        this.userinfo = user;
    };
    return UserinfoService;
}());
export { UserinfoService };
